// components/FinalCTA.jsx
import React from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Reveal } from "../lib/hooks";

export default function FinalCTA() {
  return (
    <section className="
      bg-[#f4f6fb] dark:bg-[#161b22]
      py-10 px-[6%] text-center relative overflow-hidden lg:px-80
    "
    style={{background : "rgb(var(--canvas))"}}>
      <Reveal className="lg:mx-30">
        <div className="
          flex items-center grid lg:grid-cols-5 gap-1 sm:grid-cols-1 justify-center mb-1
          [animation:fadeUp_0.8s_0.75s_cubic-bezier(.4,0,.2,1)_both]
        ">
          <span className="flex-wrap jusitify-center lg:col-span-2">
            <a href="/register/free" 
              className="pink-btn">
              Start Free
              <ArrowForwardIcon sx={{ fontSize: 20 }} className="transition-transform duration-200 group-hover:translate-x-1 mx-1" />
            </a>
            <p className="mt-4 feature-desc relative">
              Unlock AI search and all features. No card.
            </p>
          </span>
          <span className="m-2 flex justify-center lic-step-title lg:col-span-1">or</span>
          <span className="flex-wrap justify-center lg:col-span-2">
            <a href="/" 
              className="ghost-btn">
              Explore The Catalogue
            </a>
            <p className="mt-4 feature-desc relative">
              No sign up. Browse and keyword search only.
            </p>
          </span>
        </div>
      </Reveal>
    </section>
  );
}
